export const ANNUAL = 'annual';
export const TWO_YEAR = '24month';

export const TRIAL = 'trial';
export const FAMILY = 'family';

export const GIFT = 'gift';
